import { createActionTypes } from '../../../state/actions'

export const REMOVE_USER = createActionTypes('REMOVE_USER')
export const REMOVE_USER_STATUS = 'removeUser'

export const removeUser = (payload) => {
  return {
    type: REMOVE_USER.action,
    payload,
  }
}

export const removeUserSuccess = (payload) => {
  return {
    type: REMOVE_USER.success,
    payload,
  }
}

export const removeUserFailed = (error) => {
  return {
    type: REMOVE_USER.failed,
    error,
  }
}
